/// <reference no-default-lib="true"/>
/// <reference lib="WebWorker"/>
export class RequestMeta {
    constructor(
        private req: Request,
        private worker: ServiceWorkerGlobalScope
    ) {
        // must assign these all in the ctor rather than inline
        // due to https://github.com/microsoft/TypeScript/issues/44298
        this.isIdempotent = this.req.method === 'GET';
        this.isSameOrigin = this.req.url.startsWith(this.worker.location.origin);
        this.isImage = this.req.destination === 'image';
        this.isHtml = this.req.destination === 'document';
        this.isJs = this.req.destination === 'script';
        this.isCss = this.req.destination === 'style';
        this.isFont = this.req.destination === 'font';
        this.isWorker = this.req.destination === 'worker';
        this.isStatic = this.req.destination !== '';
    }

    public readonly isIdempotent: boolean;

    public readonly isSameOrigin: boolean;

    public readonly isImage: boolean;

    public readonly isHtml: boolean;

    public readonly isJs: boolean;

    public readonly isCss: boolean;

    public readonly isFont: boolean;

    public readonly isWorker: boolean;

    // https://developer.mozilla.org/en-US/docs/Web/API/Request/destination#sect1
    public readonly isStatic: boolean;
}

export class ResponseMeta {
    constructor(private res: Response) {
        // must assign these all in the ctor rather than inline
        // due to https://github.com/microsoft/TypeScript/issues/44298
        this.isValid = this.res.status === 200;
        this.contentType = this.res.headers.get('Content-Type') || '';
        this.isJson = this.contentType.includes('application/json');
        this.isHtml = this.contentType.includes('text/html');
    }

    public readonly isValid: boolean;

    public readonly contentType: string;

    public readonly isJson: boolean;

    public readonly isHtml: boolean;
}
